import { memo, useState } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { when } from "util/support";
import ToggleButton from 'ui/atoms/ToggleButton';
import { Collection } from "ui/support/Resource";
import { Filters, SelectedFilters, useFeatureFiltersContext } from "ui/widgets/Filters";

const OnboardingLogsFilters = () => {
    const [open, setOpen] = useState(false);

    const {
        filters,
        onChange,
        onApply,
        onReset
    } = useFeatureFiltersContext();

    const toggleFilters = () => setOpen(state => !state);

    return (
        <Box>
            <Paper>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2
                    }}
                >
                    <ToggleButton
                        isActive={open}
                        onClick={toggleFilters}
                        variant="outlined"
                        startIcon={<FilterAltOutlinedIcon />}
                        endIcon={<ArrowDropDownIcon />}
                    >
                        {when(
                            open,
                            'Hide Filter',
                            'Show Filter'
                        )}
                    </ToggleButton>
                    <Button
                        variant="outlined"
                        startIcon={<ArrowUpwardIcon />}
                        size='small'
                        onClick={onApply}
                    >
                        Apply
                    </Button>
                    <Button
                        variant="outlined"
                        startIcon={<RestartAltIcon />}
                        size='small'
                        onClick={onReset}
                    >
                        Reset
                    </Button>
                </Box>
                <Collapse
                    in={open}
                    unmountOnExit
                >
                    <Collection
                        sx={{
                            display: 'grid',
                            gap: 2
                        }}
                        collection={filters}
                        renderResource={filter => (
                            <Filters
                                key={filter.props.id}
                                {...filter}
                                onChange={onChange}
                            />
                        )}
                    />
                </Collapse>
            </Paper>
            <SelectedFilters
                isOpen={open}
                isBootstrapDataLoading={false}
                filters={filters}
                getFilterOptions={() => ({})}
                onChange={onChange}
            />
        </Box>
    );
};

export default memo(OnboardingLogsFilters);
